import styledTwo from "styled-components";

export default styledTwo.img`
  width: 100%;
  object-fit:cover;
`;
